module.exports = __webpack_public_path__ + "img/setup.92c80933.svg";